import { createSlice } from "@reduxjs/toolkit";

const initialState = null;

const signinDataSlice = createSlice({
  name: "signinData",
  initialState,
  reducers: {
    setSigninData: (_state, action) => action.payload,
  },
});

export const { setSigninData } = signinDataSlice.actions;
export default signinDataSlice.reducer;
